/*
 * @Author: 赵健
 * @Date: 2021-01-19 09:59:29
 * @LastEditTime: 2021-01-27 10:53:31
 * @LastEditors: 赵健
 * @Description: 商家中心API
 * @FilePath: \trunk\src\api\merchantCenter.js
 */
import request from '@/utils/request'

// 【会员中心- 商家管理】 查询商家详情
export function merchantDetails(data) {
  return request({
    url: '/api/merchant/details',
    method: 'post',
    data
  })
}

// 【会员中心- 商家管理】 修改商家记录
export function merchantEdit(data) {
  return request({
    url: '/api/merchant/edit',
    method: 'post',
    data
  })
}
// ==============================权益==================================
// 【会员中心-权益管理】 查询列表接口
export function merchantEquityList(data) {
  return request({
    url: '/api/merchant/equity/list',
    method: 'post',
    data
  })
}

// 权益板块下拉框
export function merchantEquityModuleParams(data) {
  return request({
    url: '/api/merchant/equity/moduleParams',
    method: 'post',
    data
  })
}

// 权益分类下拉框  根据板块二级联动
export function merchantEquityClassParams(data) {
  return request({
    url: '/api/merchant/equity/classParams',
    method: 'post',
    data
  })
}

// 【会员中心-权益会员等级关联】 会员等级接口
export function merchantMemberAddEqConfig(data) {
  return request({
    url: '/api/merchant/member/addEqConfig',
    method: 'post',
    data
  })
}

// 【会员中心-权益管理】 权益删除接口
export function merchantEquityDelete(data) {
  return request({
    url: '/api/merchant/equity/delete',
    method: 'post',
    data
  })
}

// 【会员中心-权益管理】 权益详情接口(编辑回显)
export function merchantEquityDetail(data) {
  return request({
    url: '/api/merchant/equity/detail',
    method: 'post',
    data
  })
}

// 【会员中心-权益分类】 查询板块分类下拉树接口
export function merchantModuleParamList(data) {
  return request({
    url: '/api/merchant/module/paramList',
    method: 'post',
    data
  })
}

// 【会员中心-权益管理】 权益下架接口
export function merchantEquityOffShelf(data) {
  return request({
    url: '/api/merchant/equity/offShelf',
    method: 'post',
    data
  })
}

// 【会员中心-权益管理】 权益上架接口
export function merchantEquityPutOnSelf(data) {
  return request({
    url: '/api/merchant/equity/putOnSelf',
    method: 'post',
    data
  })
}

// 【会员中心-权益会员等级关联】 权限会员等级管理详情接口
export function merchantMemberRelateMember(data) {
  return request({
    url: '/api/merchant/member/relateMember',
    method: 'post',
    data
  })
}

// 【会员中心-权益会员等级关联】 权限会员等级管理保存接口
export function merchantMemberInsertConfig(data) {
  return request({
    url: '/api/merchant/member/insertConfig',
    method: 'post',
    data
  })
}

// 【会员中心-权益管理】 新增权益接口
export function merchantEquityAdd(data) {
  return request({
    url: '/api/merchant/equity/add',
    method: 'post',
    data
  })
}

// 【会员中心-权益管理】 编辑权益接口
export function merchantEquityEdit(data) {
  return request({
    url: '/api/merchant/equity/edit',
    method: 'post',
    data
  })
}

// ====================== 订单管理 ==========================

// 【会员中心- 订单管理】 查询订单管理记录列表
export function merchantOrderRecordList(data) {
  return request({
    url: '/api/merchant/order/record/list',
    method: 'post',
    data
  })
}

// 【会员中心- 订单管理】 订单详情接口
export function merchantOrderRecordDetail(data) {
  return request({
    url: '/api/merchant/order/record/detail',
    method: 'post',
    data
  })
}

// 【会员中心- 订单管理】 订单确认接口
export function merchantOrderRecordConfirm(data) {
  return request({
    url: '/api/merchant/order/record/confirm',
    method: 'post',
    data
  })
}

// 【会员中心- 订单管理】 订单退回接口
export function merchantOrderRecordreturn(data) {
  return request({
    url: '/api/merchant/order/record/return',
    method: 'post',
    data
  })
}

// 【会员中心- 订单管理】 订单核销接口
export function merchantOrderRecordWriteOff(data) {
  return request({
    url: '/api/merchant/order/record/writeOff',
    method: 'post',
    data
  })
}
